
import Gene from '@/models/gene.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import Sapling from '../models/sapling.model';

@Component
export default class SaplingGeneRepresentation extends Vue {
  @Prop({ type: Object, required: true }) readonly sapling!: Sapling;
  @Prop({ type: Boolean, default: false }) readonly highlightErrors: boolean;

  get genes(): (Gene | string)[] {
    if (this.sapling.genes.length > 6) {
      return new Array(6).fill('!');
    }
    return [...this.sapling.genes, ...new Array(6 - this.sapling.genes.length).fill('?')];
  }
}
